import { ArrowRight, Images } from "lucide-react"
import { Link } from "react-router"

import type { GalleryAlbum } from "@/services/settingsService"
import { resolveGalleryImageUrl } from "./gallery-fallback"

type GalleryAlbumCardProps = {
  album: GalleryAlbum
}

export function GalleryAlbumCard({ album }: GalleryAlbumCardProps) {
  return (
    <article className="h-full overflow-hidden rounded-2xl border border-[#e8e1d7] bg-white shadow-[0_12px_32px_rgba(63,51,35,0.08)] transition duration-300 hover:-translate-y-1 hover:border-[#b89a60]/55 hover:shadow-[0_20px_42px_rgba(63,51,35,0.14)]">
      <Link
        to={`/thu-vien-anh/${encodeURIComponent(album.id)}`}
        state={{ album }}
        className="group flex size-full flex-col text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#c9aa69]"
        aria-label={`Xem album ${album.title}`}
      >
        <div className="relative aspect-[16/10] w-full overflow-hidden bg-[#27231d]">
          <img
            src={resolveGalleryImageUrl(album.cover)}
            alt={album.title}
            className="size-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/5 to-transparent" />
          <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-black/45 px-2.5 py-1 text-[11px] font-medium text-white/90 backdrop-blur-sm">
            <Images className="size-3.5" aria-hidden="true" />
            {album.images.length} ảnh
          </span>
        </div>

        <div className="flex flex-1 flex-col p-5 sm:p-6">
          <h2 className="font-serif text-xl font-semibold leading-snug text-[#30291f]">
            {album.title}
          </h2>
          <p className="mt-2 line-clamp-3 text-sm leading-6 text-[#776f65]">
            {album.description ??
              "Khám phá không gian và những trải nghiệm được lưu lại tại Nhà Cam."}
          </p>
          <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-[#c5a86c]">
            Xem album
            <ArrowRight
              className="size-3.5 transition-transform duration-300 group-hover:translate-x-1"
              aria-hidden="true"
            />
          </span>
        </div>
      </Link>
    </article>
  )
}
